export default __webpack_public_path__ + "static/front--25-34c4a680de7a3a4f5bfaed74aa1ebe26.webp";